(() => {
  if (customElements.get('rliab-coming-soon')) return;

  customElements.define('rliab-coming-soon', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const { signal } = this.events;
      const schedule = () => {
        if (this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateHeight();
        });
      };
      this.observer = new ResizeObserver(schedule);
      const observeHeader = () => {
        this.observer.disconnect();
        document.querySelectorAll('.shopify-section-group-header-group').forEach(header => {
          this.observer.observe(header);
        });
        schedule();
      };
      window.addEventListener('resize', schedule, { signal, passive: true });
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => {
        document.addEventListener(event, observeHeader, { signal });
      });
      this.updateHeight();
      observeHeader();
    }

    updateHeight() {
      if (!this.isConnected) return;
      const offset = `${Math.max(0, Math.ceil(this.getBoundingClientRect().top + window.scrollY))}px`;
      if (this.style.getPropertyValue('--nova-top-offset') !== offset) {
        this.style.setProperty('--nova-top-offset', offset);
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
})();
